import { roleConstants } from '../_constants/adminRole.constants';
export function success(roleData) { return { type: roleConstants.ROLE_SUCCESS, roleData } }